import type { OnInit } from '@angular/core';
import { Component, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { TT_ASSETS_ENDPOINT, GoogleAnalyticsService } from '@candyland/angular/shared/util-nmo';
// eslint-disable-next-line @nx/enforce-module-boundaries
import type { OverviewVideoModule, OverviewVideoModuleVideo } from '@candyland/generic/tt-com-shared-overviews';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  defaultVideo: any;
  videoGroups: any[][];

  constructor(
    private http: HttpClient,
    private gaService: GoogleAnalyticsService,
    private router: Router,
    @Inject(TT_ASSETS_ENDPOINT) private readonly assetsEndpoint: string
  ) {}

  ngOnInit() {
    this.http.get(`${this.assetsEndpoint}/data/overview_videos.json`).subscribe((data: OverviewVideoModule) => {
      this.defaultVideo = data.default;
      this.videoGroups = this.groupVideos(data.videos);
      console.log({ defaultVideo: this.defaultVideo, videoGroups: this.videoGroups });
    });
  }

  trackVideoContainerSlideChange(groupIndex: number): void {
    this.gaService.pushEvent({
      event: 'Videos',
      category: 'Startseite-Video-APA',
      titel: this.videoGroups[groupIndex][0].title,
      url: this.router.routerState.snapshot.url,
    });
  }

  private groupVideos(array: OverviewVideoModuleVideo[]): OverviewVideoModuleVideo[][] {
    const groupedVideos: OverviewVideoModuleVideo[][] = [];
    let group: OverviewVideoModuleVideo[];
    for (let i = 0; i < array.length; i++) {
      if (!(i % 3)) {
        groupedVideos.push((group = []));
      }
      group.push(array[i]);
    }
    return groupedVideos;
  }
}
